import { motion } from "framer-motion";
import AnimatedSection from "@/components/layout/AnimatedSection";
import { IMAGES, COMPANY, fadeUp } from "@/data/site";

const About = () => {
  return (
    <AnimatedSection id="sobre" className="section-padding bg-[#F5F5F5]">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div variants={fadeUp}>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-4 block">
              Sobre a Finegraf
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#234D89] mb-6">
              Excelência em Acabamentos Gráficos desde {COMPANY.foundedYear}
            </h2>

            <div className="section-divider mb-8" />

            <p className="text-[#2B2B2B] leading-relaxed mb-6">
              A <strong>Finegraf Acabamentos</strong> é referência no mercado gráfico, oferecendo serviços de acabamento com qualidade superior, responsabilidade e pontualidade que fazem a diferença para nossos clientes.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8">
              <div className="text-center p-4 bg-white rounded-2xl shadow-sm">
                <div className="text-3xl font-black text-[#E73336]">{COMPANY.foundedYear}</div>
                <div className="text-sm text-[#5C5C5C]">No mercado desde</div>
              </div>
              <div className="text-center p-4 bg-white rounded-2xl shadow-sm">
                <div className="text-3xl font-black text-[#E73336]">100%</div>
                <div className="text-sm text-[#5C5C5C]">Qualidade Garantida</div>
              </div>
              <div className="text-center p-4 bg-white rounded-2xl shadow-sm">
                <div className="text-3xl font-black text-[#E73336]">24h</div>
                <div className="text-sm text-[#5C5C5C]">Atendimento Rápido</div>
              </div>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} className="relative">
            <div className="relative overflow-hidden rounded-3xl">
              <img
                src={IMAGES.about}
                alt="Máquinas de acabamento gráfico"
                className="w-full h-auto object-cover img-zoom"
                data-testid="about-image"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#E73336] rounded-3xl -z-10" />
          </motion.div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default About;
